<mat-expansion-panel #panel="matExpansionPanel"
                     class="panel-container"
                     [ngClass]="{'panel-container--error': canMarkInvalidSection && !documentsData.isValid}">
  <mat-expansion-panel-header class="panel-header"
                              collapsedHeight="72px"
                              expandedHeight="76px">
    <ifbp-form-details-section-header [config]="documentsData.headerConfig"
                                      [iconType]="documentsData.headerIconType"
                                      [sectionBlockedData]="sectionBlockedData">
    </ifbp-form-details-section-header>
  </mat-expansion-panel-header>
  <div class="requirements">
    <ng-container *ngFor="let requirement of documentsData.requirements; last as isLast">
      <ifbp-requirement-documents-panel [requirement]="requirement"
                                        [canMarkInvalidPanel]="canMarkInvalidSection">
      </ifbp-requirement-documents-panel>
      <mat-divider *ngIf="!isLast"></mat-divider>
    </ng-container>
  </div>
</mat-expansion-panel>
